import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";
import { cn } from "@/lib/utils";

// ─────────────────────────────────────────────
// Badge
//
// Generic badge component. For status-specific
// badges use StatusBadge from common/.
// Design: §6.3 Badges
// ─────────────────────────────────────────────

const badgeVariants = cva(
  "inline-flex items-center rounded-badge px-2 py-0.5 text-[12px] font-semibold leading-none transition-colors",
  {
    variants: {
      variant: {
        default: "bg-hover text-text-secondary",
        secondary: "bg-accent-bg text-accent-text",
        destructive: "bg-danger-bg text-danger",
        outline: "border border-border-default bg-transparent text-text-secondary",
        success: "bg-success-bg text-success",
        warning: "bg-warning-bg text-warning",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
